import ServiceProviderAuth from "./ServiceProviderAuth";
import ServiceProviderAuthDetails from "./ServiceProviderAuthDetails";
export {ServiceProviderAuth, ServiceProviderAuthDetails}